import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'share-account-details',
  templateUrl: './share-account-details.component.html',
  styleUrls: ['./share-account-details.component.scss']
})
export class ShareAccountDetailsComponent implements OnInit {
  @Input() account: any;

  accountFieldsToDisplay = [
    { field: 'account_reference', header: 'Account Reference' },
    { field: 'account_balance', header: 'Account Balance', type: 'currency' },
    { field: 'account_status', header: 'Account Status', type: 'status' },
  ];

  constructor() { }

  ngOnInit(): void {
  }

  getAccountFieldValue(obj: any, field: string): any {
    const fieldParts = field.split('.');
    let value = obj;
    for (const part of fieldParts) {
      if (value && part in value) {
        value = value[part];
      } else {
        return null;
      }
    }
    return value;
  }

  getSeverity(status: string): string {
    switch (status) {
      case 'active':
        return 'success';
      case 'suspended':
        return 'warning';
      case 'closed':
        return 'danger';
      default:
        return 'info';
    }
  }

}
